/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Qr_Tab_ScaleInputs */

const vi_grower_area_qr_tab_scale = /** @type {(inputs: Grower_Area_Qr_Tab_ScaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã cân chè`)
};

/**

* @param {Grower_Area_Qr_Tab_ScaleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_qr_tab_scale = /** @type {((inputs?: Grower_Area_Qr_Tab_ScaleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Qr_Tab_ScaleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_qr_tab_scale(inputs)
});